import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  administratorList: [],
  administratorDetail: [],
  dashboardRevenue: [],
  dashboardReel: [],
  dashboardVideo: [],
  dashboardCourse: [],
  userCountTotal: [],
  educatorCountTotal: [],
  userLastMonth: [],
  receiptLatest: [],
  newUsers: [],
  bestChannels: [],
  loading: false,
  error: undefined,
  success: false,
  actionType: null,
};

const administratorSlice = createSlice({
  name: "administrator",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
      state.loading = false;
      state.success = false;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
      state.actionType = null;
    },
    actionSuccess(state, action) {
      state.success = true;
      state.loading = false;
      state.actionType = action.payload || null;
    },
    fetchAdministratorList(state, action) {
      state.administratorList = action.payload;
      state.loading = false;
    },
    fetchAdministratorDetail(state, action) {
      state.administratorDetail = action.payload;
      state.loading = false;
    },
    fetchDashboardReel(state, action) {
      state.dashboardReel = action.payload;
      state.loading = false;
    },
    fetchDashboardRevenue(state, action) {
      state.dashboardRevenue = action.payload;
      state.loading = false;
    },
    fetchDashboardVideo(state, action) {
      state.dashboardVideo = action.payload;
      state.loading = false;
    },
    fetchDashboardCourse(state, action) {
      state.dashboardCourse = action.payload;
      state.loading = false;
    },
    fetchUserCountTotal(state, action) {
      state.userCountTotal = action.payload;
      state.loading = false;
    },
    fetchUserEducatorCountTotal(state, action) {
      state.educatorCountTotal = action.payload;
      state.loading = false;
    },
    fetchUserLastMonth(state, action) {
      state.userLastMonth = action.payload;
      state.loading = false;
    },
    fetchReceiptLatest(state, action) {
      state.receiptLatest = action.payload;
      state.loading = false;
    },
    fetchNewUsers(state, action) {
      state.newUsers = action.payload;
      state.loading = false;
    },
    fetchBestChannels(state, action) {
      state.bestChannels = action.payload;
      state.loading = false;
    },
  },
});

export const administratorActions = administratorSlice.actions;

export default administratorSlice.reducer;
